"use client";

import { useId, useState } from "react";
import { Field, Select } from "../../design-system";
import "./job-title.css";

export const jobTitlePresets = [
  "대표",
  "원장",
  "부원장",
  "이사",
  "실장",
  "팀장",
  "과장",
  "대리",
  "주임",
  "사원",
  "매니저",
  "담당자",
] as const;

/** A business title is separate from permission-bearing roles. */
export function JobTitleField({
  value,
  defaultValue = "",
  onChange,
  name = "jobTitle",
  label = "직책",
  disabled = false,
}: {
  value?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
  name?: string;
  label?: string;
  disabled?: boolean;
}) {
  const hintId = useId();
  const [localValue, setLocalValue] = useState(defaultValue);
  const current = value ?? localValue;
  const [custom, setCustom] = useState(
    !!current && !jobTitlePresets.some((preset) => preset === current),
  );
  const change = (next: string) => {
    if (value === undefined) setLocalValue(next);
    onChange?.(next);
  };
  return (
    <div className="meta-crew-job-title">
      <input type="hidden" name={name} value={current} disabled={disabled} />
      <Select
        label={label}
        value={custom ? "__custom__" : current}
        disabled={disabled}
        aria-describedby={hintId}
        onChange={(event) => {
          const next = event.target.value;
          setCustom(next === "__custom__");
          change(next === "__custom__" ? "" : next);
        }}
      >
        <option value="">선택 안 함</option>
        {jobTitlePresets.map((title) => (
          <option key={title}>{title}</option>
        ))}
        <option value="__custom__">직접 입력</option>
      </Select>
      {custom && (
        <div className="meta-crew-job-title-custom">
          <Field
            label={`${label} 직접 입력`}
            value={current}
            onChange={(event) => change(event.target.value)}
            maxLength={50}
            disabled={disabled}
            placeholder="예: 콘텐츠 운영 리드"
          />
          <span className="meta-crew-job-title-count">
            {current.length} / 50자
          </span>
        </div>
      )}
      <span className="meta-crew-job-title-hint" id={hintId}>
        업무상 직책입니다. 접근 권한은 역할에서 설정합니다.
      </span>
    </div>
  );
}
